export default () => ({
  users: [],
});
